export enum ShipmentState {
  PROCESSING,
  DEPART_ORIGIN_COUNTRY,
  ARRIVE_DESTINATION_COUNTRY,
  LOCAL_SHIPPING_PROVIDER,
  DELIVERY,

  UNKNOWN,
  CANCELED,
  ERROR
}



// WEBPACK FOOTER //
// ./src/components/TrackTrace/types.ts